import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from "./service-social-group.actions";
import {map, switchMap} from "rxjs/operators";
import * as fromGraphql from "./service-social-group.graphql";
import {Apollo} from "apollo-angular";
import {Store} from "@ngrx/store";
import {AppState} from "../../../reducers";
import {NotificationService} from "../../../../services/notification.service";
import {ResponseCodeService} from "../../../../services/response-code.service";


@Injectable()
export class ServiceSocialGroupEffects {


  create$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.createServiceSocialGroups),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.CREATE_SERVICE_TARGET_SOCIAL_GROUP,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationSubService.catchError('Problem occurred while saving record'),
        map(({ data }: any) => {

          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.loadServiceSocialGroups({ serviceSocialGroups: [{id: '1', groupNames: result?.data?.groupNames }]}))
              this.notificationSubService.successMessage('Created Successfully ');
            } else {
              this.notificationSubService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  get$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getServiceSocialGroups),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_INSTITUTION_SERVICES_TARGET_GROUP,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: action.serviceUniqueId
        }
      }).pipe(
        this.notificationSubService.catchError('Problem occurred while fetching service targeted social group!'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceSocialGroups({ serviceSocialGroups: [{id: '1', groupNames: result?.data?.groupNames }]})) : []
          }
        })
      );
    })
  ), { dispatch: false });


  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationSubService: NotificationService,
    private responseCodesSubService: ResponseCodeService
  ) {}
}
